import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
// Components
import Footer from '../../Components/Footer';
import Container from '../../Components/Container';
// Services
import { sendUserInformation } from '../../services/sendUserInformation';
// Images
import blackOlibLogo from '../../Images/logo/logo_OlibWhite.svg';
import whiteOlibLogo from '../../Images/logo/logo_OlibBlack.svg';
import galeImageLargeNurse from '../../Images/Gale/galeImageLargeNurse.png';
import galeImageSmallNurse from '../../Images/Gale/galeImageSmallNurse.png';
import galeImageLargeScience from '../../Images/Gale/galeImageLargeScience.png';
import galeImageSmallScience from '../../Images/Gale/galeImageSmallScience.png';
// Logo
import { FaAngleRight } from 'react-icons/fa6';
import galeLogo from '../../Images/Gale/galeResourcesLogo.png';
// Styles
import './Gale.css';
// Translate
import { useTranslation } from 'react-i18next';

const Gale = () => {
  const { t } = useTranslation();
  const { user_email } = useSelector((state) => state.user);
  const { isMedicalInstitution, institutionCode } = useSelector(
    (state) => state.institution
  );

  const openGaleResource = (galeResourceCode) => {
    sendUserInformation('GALE', 'GALE', user_email, institutionCode);
    const galeUrl = `https://link.gale.com/apps/${galeResourceCode}?u=aquinasnetwork`;
    window.open(galeUrl, '_blank');
  };

  const galeImageLarge = isMedicalInstitution
    ? galeImageLargeNurse
    : galeImageLargeScience;
  const galeImageSmall = isMedicalInstitution
    ? galeImageSmallNurse
    : galeImageSmallScience;

  const GaleResource = ({ title, description, onClick }) => (
    <div className='galeResource'>
      <p>
        <b>Gale OneFile: {title}</b> <br />
        {description}
      </p>
      {onClick && (
        <div className='buttons'>
          <button onClick={onClick}>
            {`${t('Go to')} ${title}`} <FaAngleRight />
          </button>
        </div>
      )}
    </div>
  );

  const galeAccessSection = () => {
    const medicalDescription = t('Medical description');
    const scienceDescription = t('Science description');
    const humanDescription = t('Human description');

    return (
      <>
        {isMedicalInstitution && (
          <GaleResource
            title='Nursing and Allied Health'
            description={medicalDescription}
            onClick={() => openGaleResource('PPNU')}
          />
        )}

        <GaleResource
          title='Science (Multidisciplinary)'
          description={scienceDescription}
          onClick={() => openGaleResource('PPGS')}
        />
        {institutionCode === 'AIMS' && (
          <GaleResource
            title='Human Body interactive'
            description={humanDescription}
            onClick={() => openGaleResource('IANAT')}
          />
        )}
      </>
    );
  };

  return (
    <section className='galeSection'>
      <Container className='galeSectionContainer'>
        <div className='galeLogoSection'>
          <Link to='/'>
            <picture>
              <source srcSet={whiteOlibLogo} media='(min-width: 1200px)' />
              <img
                className='galeLogo'
                src={blackOlibLogo}
                alt='online library logo'
              />
            </picture>
          </Link>
        </div>
        <div className='galeMain'>
          <div className='galeMainImage'>
            <picture>
              <source srcSet={galeImageLarge} media='(min-width: 768px)' />
              <img
                src={galeImageSmall}
                alt='gale section description'
                loading='lazy'
              />
            </picture>
          </div>

          <div className='galeDescription'>
            <div className='galeDescriptionContainer'>
              <div className='galeDescription__title'>
                <img src={galeLogo} alt='gale logo' loading='lazy' />
                <h2>
                  <b>{t('Gale has joined our collection')} </b>
                  {t('with new and valuable resources')}
                </h2>
              </div>

              <p className='galeDescription__desc'>
                {t('We are excited to introduce')}{' '}
                <span>{t('research opportunities')}.</span>
              </p>

              <div className='galeDescription__text'>{galeAccessSection()}</div>
            </div>

            <div className='buttons'>
              <Link to='/'>{t('Back to Home')}</Link>
            </div>
          </div>
        </div>
      </Container>
      <Footer allContent={false} />
    </section>
  );
};

export default Gale;
